import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChart5"><Path d="M9.66992 3V21.001H14.3399V3H9.66992Z" fill="currentColor"/><Path d="M3 13V21.001H7.67V13H3Z" fill="currentColor"/><Path d="M16.3398 21.001V8H21.0098V21.001H16.3398Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart5;
